/**
 * Quote Response API Error Type System
 *
 * Defines error types and details for quote response operations
 * Enables type-safe error handling and user-friendly error messages
 */

export enum QuoteErrorType {
  UPLOAD_FAILED = "upload_failed",
  SUBMISSION_FAILED = "submission_failed",
  NETWORK_ERROR = "network_error",
  VALIDATION_ERROR = "validation_error",
  UNKNOWN = "unknown",
}

export interface QuoteErrorDetail {
  type: QuoteErrorType;
  message: string;
  action?: string; // User-facing action suggestion
  technicalDetail?: string; // For logging purposes
}
